export default "__VITE_ASSET__DdtfPuFi__"